import type { FormItem } from '.';
import EditProfileFormModal from '.';

interface EditProfileFormModalProps {
  title: string | null;
  formItems: FormItem[];
  onFinish?: (values: any) => void;
  onReset?: () => void;
  onCancel?: () => void;
  onFinishText?: string | null;
  onResetText?: string | null;
  onCancelText?: string | null;
}

export default function useEditProfileFormModal({
  title,
  formItems,
  onFinish,
  onReset,
  onCancel,
  onFinishText,
  onResetText,
  onCancelText,
}: EditProfileFormModalProps) {
  const [show, setShow] = useState(false);
  const [form] = Form.useForm();

  const onFinishAction = (values: any) => {
    if (onFinish) {
      onFinish(values);
    }
  };

  const onResetAction = () => {
    if (onReset) {
      form.resetFields();
      onReset();
    }
  };

  const onCancelAction = () => {
    if (onCancel) {
      onCancel();
      setShow(false);
    }
  };

  return {
    show,
    setShow,
    form,
    formModalContext: (
      <EditProfileFormModal
        show={show}
        setShow={setShow}
        title={title}
        form={form}
        formItems={formItems}
        onFinish={onFinishAction}
        onReset={onResetAction}
        onCancel={onCancelAction}
        onFinishText={onFinishText}
        onResetText={onResetText}
        onCancelText={onCancelText}
      />
    ),
  };
}
